// extracted by mini-css-extract-plugin
export default {"PageLayout":"settings-view-module__PageLayout__kGWp8BU","Pane":"settings-view-module__Pane__mAzvDYr","Content":"settings-view-module__Content__qyZc4r_"};